import apiClient from "QueryClient/axiosClient";

export const getReadinessScore = () => {
  return apiClient.get("/users/getReadinessScore");
};
